import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslationModule } from '@lib/translation';
import { SnActionsModule } from '@lib/ui/actions';
import { SnAvatarModule } from '@lib/ui/avatar';
import { SnBrandModule } from '@lib/ui/brand';
import { SnButtonModule } from '@lib/ui/button';
import { SnDataListModule } from '@lib/ui/data-list';
import { SnIconModule } from '@lib/ui/icon';
import { SnListModule } from '@lib/ui/list';
import { SnSearchbarModule } from '@lib/ui/searchbar';

import { CallSignDialogComponent } from './components/call-sign-dialog/call-sign-dialog.component';
import { CallSignListComponent } from './components/call-sign-list';
import { SnCallSignQuickChangeComponent } from './components/call-sign-quick-change';
import { SnTeamColorComponent } from './components/team-color';
import { TeamListComponent } from './components/team-list';
import { SnTeamSelectComponent } from './components/team-select';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // Material
    MatInputModule,
    MatSelectModule,
    MatChipsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatDialogModule,
    MatButtonModule,
    // Libs
    SnListModule,
    SnAvatarModule,
    SnButtonModule,
    MatButtonModule,
    SnActionsModule,
    SnIconModule,
    SnBrandModule,
    SnDataListModule,
    SnSearchbarModule,
    TranslationModule
  ],
  exports: [
    TeamListComponent,
    SnTeamColorComponent,
    CallSignListComponent,
    SnTeamSelectComponent,
    SnCallSignQuickChangeComponent,
  ],
  declarations: [
    TeamListComponent,
    SnTeamColorComponent,
    CallSignListComponent,
    SnTeamSelectComponent,
    SnCallSignQuickChangeComponent,
    CallSignDialogComponent,
  ],
})
export class SnTeamsModule {}
